// Stable color palette for the per-source-group dots in the Step 3 / Step 5 permission preview.
// Each selected group is assigned a color by its index in the available-groups list, so a group
// keeps its color as the manager toggles the selection.
export const GROUP_PALETTE = [
    "#4C8DFF", "#12B886", "#F59F00", "#E8590C",
    "#7048E8", "#E64980", "#495057", "#1098AD",
];

export const colorForIndex = (i) => GROUP_PALETTE[i % GROUP_PALETTE.length];
